import { GLOBAL_VARIABLES } from '../config'
import { loadScript } from './loadScript'

export function loadRingPool() {
  loadScript(GLOBAL_VARIABLES.libraries.DRP, () => {
    // alert();
    // Función
  })// END LOADSCRIPT
}
